export function orderStateMap(orderState) {
    switch(orderState) {
        case "TO_PAY":
            return "待支付"
        case "TO_SEND":
            return "待发货";
        case 'TO_RECEIVE':
            return "待收货";
        case 'SUCCESS':
            return "交易成功";
        case 'POST_SALE':
            return "售后中";
        case 'REFUNDED':
            return "已退款";
        case 'NEGATIVE':
            return "已拒绝";
        case 'CLOSED':
            return "已关闭";
        default:
            return "交易成功";
    }
}